import { Stack } from "@fluentui/react";
import React, { useState } from "react";
import Share from "./Share";
import Compare from "./Compare";
import Save from "./Save";
import { getDriveItemId } from "@/helpers/fallback-response-helper";
import { getToken } from "@/helpers/accessTokenHelper";
import FunctionalityButton from "./FunctionalityButton";

const stackToken = {
  childrenGap: 10,
};
const stackStyles = {
  root: {},
};

const stackItemStyle = {
  root: {
    minWidth: "60%",
  },
};

export default function FunctionalityButtonStack({ refreshDocument, setRefreshDocument, setLoading, url }) {
  const [selected, setSelected] = useState("");
  const [hovered, setHovered] = useState("");

  const openDownloadDialog = () => {
    let document = JSON.parse(sessionStorage.getItem("document"));
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const messageToShareDialog = JSON.stringify({
        access_token: await getToken(),
        documentId: document.id,
        url: context.value.url,
        documentName: document.rootDocumentName,
      });
      Office.context.ui.displayDialogAsync(
        `${process.env.BASE_URL}/Download.html`,
        {
          width: 45,
          height: 38,
          displayInIframe: true,
        },
        (result) => {
          var dialog = result.value;
          dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
            var message = JSON.parse(arg.message);
            if (message.type === "IAmReady") {
              dialog.messageChild(messageToShareDialog);
            }
            if (message.type === "close") {
              dialog.close();
            }
          });
        }
      );
    });
  };

  return (
    <Stack tokens={stackToken} styles={stackStyles}>
      <Stack.Item align="center" styles={stackItemStyle}>
        <Share
          refreshDocument={refreshDocument}
          setRefreshDocument={setRefreshDocument}
          selected={selected}
          setSelected={setSelected}
          hovered={hovered}
          setHovered={setHovered}
          heading={"Share"}
        />
      </Stack.Item>
      <Stack.Item align="center" styles={stackItemStyle}>
        <Compare 
          selected={selected}
          setSelected={setSelected}
          hovered={hovered}
          setHovered={setHovered}
          heading={"Compare"}
        />
      </Stack.Item>
      <Stack.Item align="center" styles={stackItemStyle}>
        <Save
          selected={selected}
          setSelected={setSelected}
          refreshDocument={refreshDocument}
          setRefreshDocument={setRefreshDocument}
          setLoading={setLoading}
          hovered={hovered}
          setHovered={setHovered}
        />
      </Stack.Item>
      <Stack.Item align="center" styles={stackItemStyle}>
        <div>
        <FunctionalityButton
          buttonText={"Download"}
          color="#2b579a"
          onClickFunction={openDownloadDialog}
          selected={selected}
          hovered={hovered}
          setHovered={setHovered}
        />
      </div>
      </Stack.Item>
      
    </Stack>
  );
}
